import React, { useState, useEffect } from 'react';
import './banner.css';

const Banner = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Adjust breakpoint as needed

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="section light-color-gradient">
      <div className={`container ${isMobile ? 'mobile-container' : ''}`}>
        <div>
          <div className={`text-box ${isMobile ? 'mobile-text-box' : '_500px'}`}>
            <h1 className="heading h1">WHO WE ARE</h1>
            <p className="paragraph large">
              Global Management Inc. is a multi-state conglomerate of entrepreneurial ventures spanning gas stations, hospitality, and real estate. Their core objectives are strategic portfolio diversification, sustained growth through operational efficiency (cost reduction and revenue maximization), and enhanced customer satisfaction.
            </p>
            <div className="spacer _16"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;